<template>
  <div class="banner">
    <img
      src="@/assets/images/orderBanner.png"
      alt=""
    >
    <h3 class="bannerTitle">{{$t('order.checkout')}}</h3>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
$theme-color: #d4517e;
.banner {
  position: relative;
  width: 100%;
  background-color: $theme-color;
  min-height: 50px;
  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  > .bannerTitle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 26px;
    font-weight: lighter;
  }
}
</style>